<template>
<div class="form-builder">
  <div class="accordion" id="builder_accordion">
    <SortableBuilder :scope="['form', 'form_items_attributes']" :content="content" v-slot="{ item, index }" :types="types">
      <OrderedItem
        :scope="['form', 'form_items_attributes', index]"
        :initial-item="item"
        :position="index+1"
      >
        <InformationItem
          v-if="item.item_type === 'information'"
          :initial-item="item"
          :scope="['form', 'form_items_attributes', index]"
          :locales="availableLocales"
        />
        <ImageItem
          v-else-if="item.item_type === 'image'"
          :initial-item="item"
          :scope="['form', 'form_items_attributes', index]"
          :locales="availableLocales"
        />
        <VideoItem
          v-else-if="item.item_type === 'video'"
          :initial-item="item"
          :scope="['form', 'form_items_attributes', index]"
          :locales="availableLocales"
        />
        <template v-else-if="item.item_type === 'divider'">
          <!-- The divider has zero config, this is just here so we don't hit the v-else -->
        </template>
        <FieldItem
          v-else
          :initial-item="item"
          :scope="['form', 'form_items_attributes', index]"
          :locales="availableLocales"
          :purposes="purposes"
        />
      </OrderedItem>
    </SortableBuilder>
  </div>
</div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { EveryBuildableItem, ItemType, Locale, PropType, FormItemPurpose } from "@/types";
import OrderedItem from "@/components/backend/candidacy/shared/OrderedItem.vue";
import InformationItem from "@/components/backend/candidacy/form_builder/form_items/InformationItem.vue";
import FieldItem from "@/components/backend/candidacy/form_builder/form_items/FieldItem.vue";
import SortableBuilder from "./shared/SortableBuilder.vue";
import ImageItem from "@/components/backend/candidacy/form_builder/form_items/ImageItem.vue";
import VideoItem from "@/components/backend/candidacy/form_builder/form_items/VideoItem.vue";

export default defineComponent({
  components: {
    SortableBuilder,
    FieldItem,
    OrderedItem,
    InformationItem,
    ImageItem,
    VideoItem,
  },
  name: "FormBuilder",
  props: {
    currentLocale: {
      type: String as PropType<Locale>,
      default() {
        return "en"
      }
    },
    content: {
      type: Array as PropType<EveryBuildableItem[]>,
      default() {
        return [{}]
      }
    },
    availableLocales: {
      type: Array as PropType<Locale[]>,
      required: true,
    },
    types: {
      type: Array as PropType<ItemType[]>,
      required: true,
    },
    purposes: {
      type: Array as PropType<FormItemPurpose[]>,
      required: true
    }
  },
});
</script>

<style>
.form-builder {
  margin-bottom: 1rem;
}
.plus-btn {
  width: 8rem;
}

.list-move, /* apply transition to moving elements */
.list-enter-active,
.list-leave-active {
  transition: all 0.5s ease;
}

.list-enter-from,
.list-leave-to {
  opacity: 0;
  transform: translateX(30px);
}

/* ensure leaving items are taken out of layout flow so that moving
   animations can be calculated correctly. */
.list-leave-active {
  position: absolute;
}
</style>
